// import z from "zod";

export default {
	getAll: {
		body: undefined,
		query: undefined,
		params: undefined,
	},
};
